import { FETCH_START, FETCH_END } from './ActionTypes';
import axios from '../../../axios.conf';
import { toast as globalToast } from '../../../components/ToastManager';
import secureLocalStorage from 'react-secure-storage';
import { handleExecutionLog } from '../../../components/ExecutionLogHandler';

const BASE_API = 'manufacturer-chargeback/contract';

const fetchStart = () => ({ type: FETCH_START });
const fetchEnd = () => ({ type: FETCH_END });

export const createManufacturerChargebackContracts = (data, id, type) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await createChargebackContractsAPI(data, id, type);
      dispatch(fetchEnd());

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response?.data?.message || response?.data?.response);
        return { success: true, response };
      }
    } catch (error) {
      dispatch(fetchEnd());
      const logNumber = error.response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response: error.response };
      }
      throw error;
    }
  };
};

const createChargebackContractsAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  if (type === 'edit') {
    return axios.put(BASE_API, { ...data }, { headers });
  } else if (type === 'delete') {
    return axios.delete(`${BASE_API}/${id}`, { headers });
  } else {
    return axios.post(BASE_API, data, { headers });
  }
};
